// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".localized-text[data-v-39e81b16]{white-space:pre-wrap}.search-code-form[data-v-39e81b16] .el-input .el-input__inner{text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
